import React from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { LoginStateProvider } from './LoginContext';
import { LoginForm } from './LoginForm';
import { ResetPasswordRouter } from './ResetPassword';
import { ClientChooser } from './ClientChooser';
import { LoginShell } from './LoginShell';

export default function Login() {
	return (
		<BrowserRouter basename={`/login`}>
			<LoginStateProvider>
				<LoginShell>
					<Switch>
						<Route exact path={`/`} component={LoginForm} />
						<Route path={`/reset`} component={ResetPasswordRouter} />
						<Route path={`/choose-client`} component={ClientChooser} />
						<Redirect to={`/`} />
					</Switch>
				</LoginShell>
			</LoginStateProvider>
			<Toaster position="bottom-right" />
		</BrowserRouter>
	);
}
